<template>
<div class="chapter">
<div class="inner_page">
<div class="pseudo_margin_1"></div>
<div class="section" id="section006">
<div class="pseudo_margin_2"></div>
<div class="pseudo_margin_2"></div>
<div class="pseudo_margin_1"></div>
<div class="centered_text">
<p class="halftitle1"><a id="page_vi"></a><a id="page_vii"></a>RIVER HOUSE</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frontmatter003.vue?19388f7b